<template>
  <div>
    <title-header title='申请分销员'></title-header>
    <div class="apply-content">
      <!-- 申请界面 -->
      <div v-if='!display.showSuccess'>
        <van-field v-model="name" required label="真实姓名" placeholder="" size="large" />
        <van-field v-model="phone" label="手机号" readonly placeholder="" size="large" />
        <van-field
          v-model="phoneCode"
          center
          required
          size="large"
          label="短信验证码"
          placeholder="请输入短信验证码"
        >
          <van-button slot="button" size="small" color="#45C5DA" type="primary" @click="sendCode">
            <span v-show="!display.showWait">发送验证码</span>
            <span v-show="display.showWait">{{waitSecond}}s</span>
          </van-button>
        </van-field>
        <div class="apply-btn-box">
          <van-button type="primary" style="width: 35vw;" color='#45C5DA' @click="confirmApply">确认提交</van-button>
        </div>
      </div>
      <!-- 申请成功提交 -->
      <div v-else>
        <div class='apply-success'>您的注册申请已提交，注册结果会以短信通知提醒您，请耐心等待！</div>
        <div class="apply-btn-box">
          <van-button style="width: 35vw;" @click="confirmSuccess">确认</van-button>
        </div>
      </div>
    </div>
    <geetest
      ref="geetest"
      :phone="phone"
      :page-code="pageCode"
      :val-code="pageCode"
      @send-code-success="handlerSendCodeSuccess"
      @send-code-error="handlerSendCodefailed"
    ></geetest>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import geetest from "components/geetest/geetest.vue";
  import api from 'api/user';
  import { randomString } from 'common/js/utils';
  import { Toast } from 'vant';
  export default {
    components: {
      geetest
    },
    data() {
      return {
        display: {
          showWait: false,
          showSuccess: false
        },
        name: '',
        phoneCode: '', //验证码
        waitSecond: 60,
        pageCode: '',
        pageCode: randomString(8), //手机验证所需要的随机字符串
      }
    },
    computed: {
      phone() {
        return this.$store.state.userInfo.mobilePhone;
      },
      ...mapState(['userInfo'])
    },
    methods: {
      //发送验证码
      sendCode() {
        this.$refs.geetest.verify();
      },
      //发送验证码成功
      handlerSendCodeSuccess() {
        this.display.showWait = true;
        this.secondWait()
      },
      //发送失败
      handlerSendCodefailed() {

      },
      //提交审核
      confirmApply() {
        if(!this.name) {
          Toast('请输入真实姓名');
          return;
        }
        api.applyDistributor({
          realName: this.name,
          smsCode: this.phoneCode
        })
          .then(res=>{
            this.display.showSuccess = true;
          })
      },
      //返回我的界面
      confirmSuccess() {
        this.$router.push({
          name: 'mine'
        })
      },
      secondWait: function() {
        let _this = this;
        _this.setInercalID = setTimeout(function() {
          if (_this.waitSecond > 0) {
            _this.waitSecond = _this.waitSecond - 1;
            _this.secondWait();
          } else {
            _this.display.showWait = false;
            clearTimeout(_this.setInercalID);
            _this.waitSecond = 60;
          }
        }, 1000);
      },
    }
  }
</script>
<style scoped lang='scss'>
  .apply-content{
    padding: 15px;
    .apply-btn-box{
      display: flex;
      margin-top: 100px;
      justify-content: center;
    }
  }
  .apply-success{
    margin-top: 20vh;
  }
</style>